import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useInvestorActivePropertiesQuery, useInvestorAppDataQuery } from 'services/apollo';
import { ActivePropertyItem } from 'services/apollo/multisto';

import { Loading, Row, Col, Select } from 'atoms';
import PropertiesGrid from './components/PropertiesGrid';
import FilterActiveProperties from './FilterActiveProperties';

const ActiveProperties: React.FC = () => {
  const { t } = useTranslation();
  const [sort, setSort] = useState('');
  const { data, loading } = useInvestorActivePropertiesQuery({
    variables: {
      buyEnabledFilterInput: {
        isBuyStoEnabled: true,
      },
    },
    fetchPolicy: 'no-cache',
  });
  const { data: appData, loading: appDataLoading } = useInvestorAppDataQuery();

  useEffect(() => {
    const defaultSort = appData?.investorAppParameters.defaultPropertyOrder.default;
    if (defaultSort && defaultSort !== '') {
      setSort(defaultSort);
    }
  }, [appData]);

  if (!data || loading || !appData || appDataLoading) {
    return <Loading />;
  }
  const { investorActiveProperties } = data;
  const onChange = ({ value }: { value: string }) => {
    setSort(value);
  };

  const getValue = (firstValue: ActivePropertyItem, name: string) => {
    // dates must be first converted to date for proper comparison
    switch (name) {
      case 'createdAt':
        return new Date(firstValue[name]);
      default:
        return firstValue[name as keyof typeof firstValue];
    }
  };
  const {
    isPropertySortingEnabled,
    defaultPropertyOrder,
    isBuyStoWhitelistPerInvestorEnabled,
    isFilterPreferencesEnabled,
  } = appData.investorAppParameters;

  const sorted = sort
    ? [...investorActiveProperties].sort((a, b) => {
        const [name, type] = sort.split('-') as ['projectCost' | 'popularity' | 'createdAt', 'asc' | 'desc'];
        return type === 'asc' ? getValue(a, name) - getValue(b, name) : getValue(b, name) - getValue(a, name);
      })
    : [];

  const properties = sorted.length ? sorted : investorActiveProperties;

  const buyPorperties: ActivePropertyItem[] = [];
  const nonBuyPorperties: ActivePropertyItem[] = [];

  properties.map((p) =>
    !p.isBuyButtonEnabled || (!p.isInvestorBuyEnabled && isBuyStoWhitelistPerInvestorEnabled)
      ? nonBuyPorperties.push(p)
      : buyPorperties.push(p),
  );

  const sortOptions = defaultPropertyOrder.options.map((o) => {
    return {
      ...o,
      // converting to i18n translation
      label: t(o.label),
    };
  });

  const selected = sortOptions.find((c) => c.value === sort);
  return (
    <div className="content">
      {isPropertySortingEnabled ? (
        <Row className="mb-4">
          <Col md={4}>
            <Select options={sortOptions} value={selected} onChange={onChange} />
          </Col>
        </Row>
      ) : null}
      <PropertiesGrid properties={buyPorperties} appData={appData.investorAppParameters} />
      <br />
      {isFilterPreferencesEnabled ? (
        <FilterActiveProperties properties={properties} parameters={appData.investorAppParameters} />
      ) : null}
      <PropertiesGrid properties={nonBuyPorperties} isClosedOffering appData={appData.investorAppParameters} />
    </div>
  );
};

export default ActiveProperties;
